import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { authenticate, setToken, setUserInvoiceDetails } from "../../../feature/getInvoiceByEmailSlice"
import { getInvoiceUserDetailsApi } from "../../../service/auth/getInvoiceByEmailApi";
import Loader from "../../loader";

function GetInvoiceByEmail(props) {
    const dispatch = useDispatch();
    const [loadingActive, setLoadingActive] = useState(false)

    const navigate = useNavigate();
    const { authorized } = useSelector(state => state.auth)
    const getInvoiceByEmailData = useSelector(state => state.GetInvoiceByEmail)

    //Get the verification token
    const { token } = useParams();

    useEffect(() => {
        if (token) {
            dispatch(setToken(token));
            let data = { token: token }
            setLoadingActive(true);
            try {
                dispatch(getInvoiceUserDetailsApi(data, (responseData) => {
                    if (responseData?.data?.result?.PhoneNumber && responseData?.data?.result?.InvoiceId) {
                        setLoadingActive(false);
                        dispatch(setUserInvoiceDetails(responseData.data.result))
                        dispatch(authenticate(true));
                        if (authorized) {
                            const dataToSend = { Id: responseData?.data?.result?.InvoiceId, data: { Value: { CanApprove: true } }, tab: "Pending for Approval" }
                            navigate("/verificationEditScreen", { state: dataToSend });
                        } else {
                            navigate("/login")
                        }
                    }
                },
                    (err) => {
                        dispatch(setToken(null));
                        dispatch(authenticate(false));
                        navigate("/login")
                        setLoadingActive(false);
                    }
                )
                );
            } catch (error) {
            }

        }
    }, [token])

    return (
        <>
            <Loader show={loadingActive} />
        </>
    );
}

export default GetInvoiceByEmail;
